import { ktLng } from './keisukeAdapterI18n';

/** Methods / Results 見出し付き論文用テキスト */
export function formatPaperDocument(lng: string, methodsBody: string, resultsBody: string): string {
  return `${ktLng(lng, 'paper.sections.methods')}\n\n${methodsBody}\n\n${ktLng(lng, 'paper.sections.results')}\n\n${resultsBody}`;
}

/** 英語固定本文に UI 言語の見出しだけ当てる（未翻訳本文の暫定） */
export function localizePaperHeadings(lng: string, englishDocument: string): string {
  if (lng === 'en') return englishDocument;
  const methods = ktLng(lng, 'paper.sections.methods');
  const results = ktLng(lng, 'paper.sections.results');
  return englishDocument
    .replace(/^Methods\n\n/, `${methods}\n\n`)
    .replace(/\n\nResults\n\n/, `\n\n${results}\n\n`);
}
